/* eslint-disable no-undef */
<template>
  <div class="ai-control-panel">
    <div class="prompts-container">
      <!-- User Profile (用户画像) -->
      <div class="prompt-column">
        <div class="row-header">
            <span class="label">用户画像</span>
            <div class="mini-actions">
                <el-button link type="primary" size="small" @click="openLoadDialog('profile')">加载</el-button>
                <el-button link type="success" size="small" @click="openSaveDialog('profile')">保存</el-button>
                <el-button link type="warning" size="small" @click="openFullscreen('profile')">全屏</el-button>
            </div>
        </div>
        <el-input
          v-model="localUserProfile"
          type="textarea"
          :rows="8"
          placeholder="描述你的音乐偏好 (例如: 我喜欢民谣和轻音乐，偏好华语歌曲)"
          class="profile-input"
          resize="none"
        ></el-input>
      </div>

      <!-- User Playlist (参考歌单) -->
      <div class="prompt-column">
         <div class="row-header">
              <span class="label">用户歌曲</span>
              <div class="mini-actions">
                  <el-button link type="primary" size="small" @click="openLoadDialog('playlist')">加载</el-button>
                  <el-button link type="success" size="small" @click="openSaveDialog('playlist')">保存</el-button>
                  <el-button link type="warning" size="small" @click="openFullscreen('playlist')">全屏</el-button>
              </div>
         </div>
         <el-input
          v-model="localUserPlaylist"
          type="textarea"
          :rows="8"
          placeholder="粘贴你喜欢的歌曲列表，作为推荐参考..."
          class="playlist-input"
          resize="none"
        ></el-input>
      </div>

      <!-- User Prompt (场景需求) -->
      <div class="prompt-column">
         <div class="row-header">
              <span class="label">场景需求</span>
              <div class="mini-actions">
                  <el-button link type="primary" size="small" @click="openLoadDialog('user')">加载</el-button>
                  <el-button link type="success" size="small" @click="openSaveDialog('user')">保存</el-button>
                  <el-button link type="warning" size="small" @click="openFullscreen('user')">全屏</el-button>
              </div>
         </div>
         <el-input
          v-model="localPrompt"
          type="textarea"
          :rows="8"
          placeholder="描述你想听什么歌 (例如: 推荐适合下雨天听的歌)"
          class="main-input"
          resize="none"
        ></el-input>
      </div>
    </div>

    <div class="action-row" style="position: relative; justify-content: center;">
      <el-checkbox v-model="localEnableSearch" style="position: absolute; left: 0;">联网搜索 (仅支持的模型生效)</el-checkbox>

      <!-- 模型选择 -->
      <div style="position: absolute; right: 0; display: flex; align-items: center; gap: 10px;">
        <span style="color: #606266; font-size: 14px;">选择模型:</span>
        <el-select
          v-model="selectedModels"
          multiple
          placeholder="选择要对比的模型"
          style="width: 300px;"
          :max-collapse-tags="2"
        >
          <el-option
            v-for="model in aiModels.filter(m => m.is_active)"
            :key="model.id"
            :label="model.name"
            :value="model.model_id"
          />
        </el-select>
      </div>

      <div class="action-buttons">
         <el-button
           type="primary"
           @click="handleSend"
           :loading="Object.values(aiResponses).some(r => r.loading)"
           :disabled="selectedModels.length === 0"
           style="width: 200px;"
         >发送</el-button>
      </div>
    </div>
  </div>

  <!-- Save Prompt Dialog -->
  <el-dialog v-model="saveDialogVisible" title="保存提示词" width="30%">
    <el-form :model="saveForm">
      <el-form-item label="标题">
        <el-input v-model="saveForm.title" placeholder="例如: 摇滚乐鉴赏专家" @keyup.enter="confirmSavePrompt"></el-input>
      </el-form-item>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="saveDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmSavePrompt">保存</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- Load Prompt Dialog -->
  <el-dialog v-model="loadDialogVisible" :title="'已保存的' + (getTypeConfig(currentType)?.name || '')" width="60%">
    <el-table :data="savedPrompts[currentType]" stripe style="width: 100%" height="400">
       <el-table-column prop="title" label="标题" width="180"></el-table-column>
       <el-table-column label="内容" show-overflow-tooltip>
           <template #default="scope">
               {{ scope.row.content }}
           </template>
       </el-table-column>
        <el-table-column prop="date" label="保存时间" width="180"></el-table-column>
       <el-table-column label="操作" width="150" fixed="right">
         <template #default="scope">
           <el-button link type="primary" size="small" @click="applyPrompt(scope.row)">加载</el-button>
           <el-button link type="danger" size="small" @click="deletePrompt(scope.row.id)">删除</el-button>
         </template>
       </el-table-column>
    </el-table>
  </el-dialog>

  <!-- Fullscreen Prompt Dialog -->
  <el-dialog v-model="fullscreenDialogVisible" :title="(getTypeConfig(fullscreenType)?.name || '') + ' - 全屏编辑'" fullscreen>
      <el-input
          v-if="fullscreenType"
          v-model="getTypeConfig(fullscreenType).content"
          :model-value="getTypeConfig(fullscreenType).content"
          @update:modelValue="getTypeConfig(fullscreenType).setter"
          type="textarea"
          :rows="25"
          placeholder="请输入内容..."
          style="font-family: monospace; font-size: 16px;"
      ></el-input>
      <template #footer>
          <span class="dialog-footer">
              <el-button type="primary" @click="fullscreenDialogVisible = false">完成</el-button>
          </span>
      </template>
  </el-dialog>

  <!-- Dynamic Multi-Model Display -->
  <div class="ai-container" :style="selectedModels.length > 0 ? { 'grid-template-columns': `repeat(${selectedModels.length}, 1fr)` } : {}">
    <div v-for="modelId in selectedModels" :key="modelId" class="ai-column">
      <div class="ai-header">
        <div class="ai-title">
          {{ aiModels.find(m => m.model_id === modelId)?.name || modelId }}
        </div>
        <div v-if="aiResponses[modelId]?.loading" class="loading-indicator">正在推荐...</div>
      </div>
      <div class="ai-body">
        <div class="ai-response" v-if="aiResponses[modelId]?.title || aiResponses[modelId]?.tracks.length > 0">
          <div class="structured-result">
              <div class="result-header">
                  <div class="playlist-title">{{ aiResponses[modelId].title || '生成中...' }}</div>
                  <div class="playlist-vibe" v-if="aiResponses[modelId].reason">{{ aiResponses[modelId].reason }}</div>
              </div>

              <div class="tracks-list" v-if="aiResponses[modelId].tracks.length > 0">
                  <div v-for="(track, index) in aiResponses[modelId].tracks" :key="index" class="track-item">
                      <div class="track-header">
                          <span class="track-index">{{ index + 1 }}.</span>
                          <span class="track-title">{{ track.song_name }}</span>
                          <span class="track-artist">{{ track.singer_name }}</span>
                      </div>
                      <div class="track-reason" v-if="track.reason">{{ track.reason }}</div>
                  </div>
              </div>

              <div class="result-actions" v-if="aiResponses[modelId].tracks.length > 0">
                  <el-button type="primary" size="small" @click="copyPlaylist(aiResponses[modelId].title, aiResponses[modelId].tracks)">一键复制歌单</el-button>
              </div>
           </div>
        </div>
        <div v-else class="empty-state">等待输入...</div>
      </div>
    </div>

    <!-- 空状态提示 -->
    <div v-if="selectedModels.length === 0" class="empty-placeholder" style="grid-column: 1 / -1;">
      <div class="empty-state" style="margin-top: 100px;">
        <p style="font-size: 16px;">请先选择要对比的模型</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, computed } from 'vue';
import { ElMessage } from 'element-plus';

const props = defineProps({
  userProfile: String,
  userPlaylist: String,
  prompt: String,
  enableSearch: Boolean,
  aiModels: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:userProfile', 'update:userPlaylist', 'update:prompt', 'update:enableSearch']);

const localUserProfile = computed({
  get: () => props.userProfile,
  set: (val) => emit('update:userProfile', val)
});

const localUserPlaylist = computed({
  get: () => props.userPlaylist,
  set: (val) => emit('update:userPlaylist', val)
});

const localPrompt = computed({
  get: () => props.prompt,
  set: (val) => emit('update:prompt', val)
});

const localEnableSearch = computed({
  get: () => props.enableSearch,
  set: (val) => emit('update:enableSearch', val)
});

// 选中的模型列表（用户可多选）
const selectedModels = ref([]);

// AI 响应状态（动态管理，key 为 model_id）
const aiResponses = reactive({});

// 确保选中模型有对应的响应状态
const ensureModelState = (modelId) => {
  if (!aiResponses[modelId]) {
    aiResponses[modelId] = {
      title: '',
      reason: '',
      tracks: [],
      loading: false,
      totalTracks: 0
    };
  }
};

// AI Actions - DSV 流式推荐
const sendStreamingRecommendation = async (modelId) => {
  ensureModelState(modelId);
  const target = aiResponses[modelId];

  target.loading = true;
  target.title = '';
  target.reason = '';
  target.tracks = [];
  target.totalTracks = 0;

  try {
    const response = await fetch('/zy/curator/playlist/stream/dsv', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prompt: localPrompt.value,
        user_profile: localUserProfile.value,
        user_playlist: localUserPlaylist.value,
        model: modelId,
        enable_search: localEnableSearch.value
      })
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    let isReading = true;
    while (isReading) {
      const { done, value } = await reader.read();
      if (done) {
        isReading = false;
        continue;
      }

      buffer += decoder.decode(value, { stream: true });

      // 解析 SSE 事件
      const lines = buffer.split('\n');
      buffer = lines.pop() || '';  // 保留最后一行（可能不完整）

      let currentEvent = null;
      for (const line of lines) {
        if (line.startsWith('event: ')) {
          currentEvent = line.slice(7).trim();
        } else if (line.startsWith('data: ') && currentEvent) {
          const data = JSON.parse(line.slice(6));

          switch (currentEvent) {
            case 'header':
              if (data.title) target.title = data.title;
              if (data.reason) target.reason = data.reason;
              break;
            case 'track':
              target.tracks.push({
                song_name: data.song_name,
                singer_name: data.singer_name,
                reason: data.reason || ''
              });
              break;
            case 'done':
              target.totalTracks = data.total_tracks;
              break;
            case 'error':
              ElMessage.error(data.message || '推荐失败');
              break;
          }
          currentEvent = null;
        }
      }
    }

    if (target.tracks.length > 0) {
      const modelName = props.aiModels.find(m => m.model_id === modelId)?.name || modelId;
      ElMessage.success(`${modelName} 推荐完成，共 ${target.tracks.length} 首歌曲`);
    }

  } catch (err) {
    console.error('Streaming error:', err);
    ElMessage.error(`网络错误: ${err.message}`);
  } finally {
    target.loading = false;
  }
};

const copyPlaylist = (title, tracks) => {
    if (!tracks || !tracks.length) return;

    let text = '';
    if (title) text += `${title}\n`;

    text += tracks.map((t, index) => {
        let line = `${index + 1}. ${t.song_name} - ${t.singer_name}`;
        if (t.reason) line += ` (${t.reason})`;
        return line;
    }).join('\n');

    if (navigator.clipboard) {
        navigator.clipboard.writeText(text).then(() => ElMessage.success('歌单已复制'));
    } else {
        const ta = document.createElement('textarea');
        ta.value = text;
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        ElMessage.success('歌单已复制');
    }
};

const handleSend = () => {
  if (!localPrompt.value.trim()) {
      ElMessage.warning('请输入场景需求');
      return;
  }

  if (selectedModels.value.length === 0) {
      ElMessage.warning('请至少选择一个模型');
      return;
  }

  // 为每个选中的模型发起推荐
  selectedModels.value.forEach(modelId => {
      sendStreamingRecommendation(modelId);
  });
};

// --- Prompt Persistence (Split by Type) ---
const savedPrompts = reactive({
    profile: [],
    user: [],
    playlist: []
});

const currentType = ref('user'); // 'profile', 'user'
const saveDialogVisible = ref(false);
const loadDialogVisible = ref(false);
const saveForm = reactive({ title: '' });

// Fullscreen Editing
const fullscreenType = ref(null);
const fullscreenDialogVisible = ref(false);

const openFullscreen = (type) => {
    fullscreenType.value = type;
    fullscreenDialogVisible.value = true;
};

// Helper to get logic by type
const getTypeConfig = (type) => {
    switch(type) {
        case 'profile': return {
            name: '用户画像',
            storageKey: 'musicagent_saved_prompts_profile',
            content: localUserProfile.value,
            setter: (val) => localUserProfile.value = val
        };
        case 'user': return {
            name: '场景需求',
            storageKey: 'musicagent_saved_prompts_user',
            content: localPrompt.value,
            setter: (val) => localPrompt.value = val
        };
        case 'playlist': return {
            name: '用户歌曲',
            storageKey: 'musicagent_saved_prompts_playlist',
            content: localUserPlaylist.value,
            setter: (val) => localUserPlaylist.value = val
        };
    }
};

const loadAllSavedPrompts = () => {
    ['profile', 'user', 'playlist'].forEach(type => {
        const config = getTypeConfig(type);
        if (!config) return;
        const key = config.storageKey;
        const stored = localStorage.getItem(key);
        if (stored) {
            savedPrompts[type] = JSON.parse(stored);
        }
    });
};

const openSaveDialog = (type) => {
  const config = getTypeConfig(type);
  if (!config.content || !config.content.trim()) {
    ElMessage.warning(`${config.name}内容为空，无法保存`);
    return;
  }
  currentType.value = type;
  saveForm.title = '';
  saveDialogVisible.value = true;
};

const openLoadDialog = (type) => {
    currentType.value = type;
    loadDialogVisible.value = true;
};

const confirmSavePrompt = () => {
  if (!saveForm.title.trim()) {
      ElMessage.warning('请输入标题');
      return;
  }

  const type = currentType.value;
  const config = getTypeConfig(type);

  const newPrompt = {
    id: Date.now(),
    title: saveForm.title.trim(),
    content: config.content, // Save just the specific content
    date: new Date().toLocaleString()
  };

  savedPrompts[type].unshift(newPrompt); // Add to top
  localStorage.setItem(config.storageKey, JSON.stringify(savedPrompts[type]));

  saveDialogVisible.value = false;
  ElMessage.success('保存成功');
};

const deletePrompt = (id) => {
  const type = currentType.value;
  const config = getTypeConfig(type);
  savedPrompts[type] = savedPrompts[type].filter(p => p.id !== id);
  localStorage.setItem(config.storageKey, JSON.stringify(savedPrompts[type]));
  ElMessage.success('删除成功');
};

const applyPrompt = (promptObj) => {
  const type = currentType.value;
  const config = getTypeConfig(type);
  config.setter(promptObj.content);
  loadDialogVisible.value = false;
  ElMessage.success(`已加载 "${promptObj.title}"`);
};

onMounted(() => {
    loadAllSavedPrompts();
});
</script>

<style scoped>
.ai-control-panel {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  margin-bottom: 20px;
}

.row-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;
}

.label {
    font-weight: bold;
    color: #606266;
    display: block;
}

.prompts-container {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.prompt-column {
    flex: 1;
    min-width: 0;
}

.mini-actions .el-button {
    padding: 0 5px;
    height: auto;
}

.action-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ai-container {
  display: grid;
  gap: 20px;
  min-height: 500px;
}

.ai-column {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
}

.ai-header {
  padding: 15px;
  border-bottom: 1px solid #ebeef5;
  background: #f5f7fa;
  border-radius: 8px 8px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ai-title {
  font-weight: bold;
  font-size: 16px;
  color: #303133;
}

.loading-indicator {
  font-size: 12px;
  color: #409EFF;
}

.ai-body {
  padding: 15px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.ai-response {
  flex: 1;
  background: #f9fafc;
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e4e7ed;
  overflow-y: auto;
  max-height: 500px;
}

.empty-state {
  text-align: center;
  color: #909399;
  margin-top: 50px;
}

/* Structured Result Styles */
.structured-result {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.result-header {
    margin-bottom: 15px;
    border-bottom: 2px solid #409EFF;
    padding-bottom: 10px;
}

.playlist-title {
    font-size: 18px;
    font-weight: bold;
    color: #303133;
}

.playlist-vibe {
    font-size: 14px;
    color: #909399;
    margin-top: 5px;
}

.tracks-list {
    margin-bottom: 20px;
}

.track-item {
    padding: 10px;
    border-bottom: 1px solid #ebeef5;
}

.track-item:last-child {
    border-bottom: none;
}

.track-header {
    margin-bottom: 5px;
}

.track-index {
    color: #909399;
    margin-right: 8px;
    font-weight: bold;
}

.track-title {
    font-weight: bold;
    color: #303133;
    font-size: 15px;
}

.track-artist {
    color: #606266;
    font-size: 14px;
    margin-left: 5px;
}

.track-artist::before {
    content: "- ";
}

.track-reason {
    font-size: 13px;
    color: #606266;
    margin-bottom: 4px;
    line-height: 1.5;
}

.result-actions {
    margin-top: 20px;
    text-align: center;
    position: sticky;
    bottom: 0;
    background: linear-gradient(to top, #fff 80%, transparent);
    padding: 10px 0;
}
</style>
